/**
 * teamsOfUser
 *
 * A person's analytics teams: the business groups on their user record that
 * `parameters/analytics.teamBusinessGroups` marks as teams. The sales-credit booking trigger, the
 * backfill, the analytics service scope resolver and React all decide a person's teams here and
 * nowhere else. Both inputs are read as stored, so an absent or non-array value, and any
 * non-string entry, reads as no group. The result is sorted by code unit and distinct, so two
 * calls on the same groups yield equal lists whatever the stored order.
 */

import type { DocId } from '../System.types';

const idsOf = (value: unknown): DocId[] =>
  Array.isArray(value) ? value.filter((id): id is DocId => typeof id === 'string') : [];

export const teamsOfUser = (businessGroups: unknown, teamBusinessGroups: unknown): DocId[] => {
  const marked = new Set(idsOf(teamBusinessGroups));
  return [...new Set(idsOf(businessGroups).filter((id) => marked.has(id)))].sort();
};
